module.exports = __webpack_public_path__ + "static/account-168d4f48136db7050aae39ed8b4820ac.jpg";